import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { stats } from '@/mocks/about';

const quickChips = [
  { id: 'ent', label: '娱乐爆料' },
  { id: 'tech', label: '科技数码' },
  { id: 'finance', label: '财经观察' },
  { id: 'society', label: '社会热点' },
];

export default function HeroSection() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = query.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : '/topics');
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20editorial%20abstract%20background%20with%20swirling%20warm%20vermilion%20and%20amber%20light%20streaks%20over%20deep%20charcoal%20dark%20surface%2C%20cinematic%20high%20contrast%2C%20minimal%20artistic%2C%20no%20text&width=1600&height=900&orientation=landscape&seq=baoliao-hero-01"
          alt="爆料专区首页入口与网址导航首屏背景"
          title="爆料专区首页入口与网址导航"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />

      <div className="relative w-full px-4 md:px-8 lg:px-12 pt-24 md:pt-28 pb-12">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur">
            <i className="ri-fire-line text-accent-400" />
            每日维护 · 热门讨论区每小时更新
          </span>

          <h1 className="font-heading mt-6 text-3xl md:text-6xl font-bold leading-tight text-background-50">
            爆料专区首页入口
            <br />
            与网址网页站点导航
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg leading-relaxed text-background-200">
            想找爆料专区首页、入口、网址、网页、站点？这里整理了最全的访问路径，直达热门讨论区与最新爆料帖，不用再四处搜索。收藏本页，随时获取第一手资讯。
          </p>

          <form onSubmit={handleSearch} className="mt-8 flex flex-col sm:flex-row gap-2.5 max-w-xl" role="search">
            <label htmlFor="hero-search" className="sr-only">
              搜索话题
            </label>
            <input
              id="hero-search"
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索你想看的话题，如：新品爆料"
              className="flex-1 min-w-0 px-4 py-3.5 rounded-md bg-background-50/95 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none border border-transparent focus:border-accent-400"
            />
            <button
              type="submit"
              className="shrink-0 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line" />
              搜索入口
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-300">热门分类：</span>
            {quickChips.map((chip) => (
              <button
                key={chip.id}
                type="button"
                onClick={() => navigate(`/topics?category=${chip.id}`)}
                className="px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-xs text-background-100 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
              >
                {chip.label}
              </button>
            ))}
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl">
          {stats.map((item) => (
            <div key={item.id} className="border-l-2 border-accent-500/60 pl-4">
              <dt className="font-heading text-2xl md:text-3xl font-bold text-background-50">{item.value}</dt>
              <dd className="mt-1 text-xs md:text-sm text-background-300">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}